export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'defaultImageUrl',
    width: 80,
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: '产品名称',
    field: 'displaySkuName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySkuName' },
  },
  {
    title: '品牌名称',
    field: 'brandName',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayBrand' },
  },
  {
    title: '产品尺寸',
    field: 'goodsSize',
    minWidth: 160,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySize' },
  },
  {
    title: '工厂单价(rmb)',
    field: 'ftyPrice',
    minWidth: 140,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: '单品包装',
    field: 'displayUnit',
    minWidth: 160,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayUnit' },
  },
  {
    title: '产品属性',
    field: 'goodsProperties',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: '纸箱',
    field: 'ctnLength',
    minWidth: 160,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayBox' },
  },
  {
    title: '材料信息',
    field: 'materialInfo',
    width: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: '英文材料信息',
    field: 'materialInfoEn',
    width: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: '装箱入数',
    field: 'inCtnQty',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: '企划人员',
    field: 'designName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayDesignName' },
  },
]
